export default __webpack_public_path__ + "images/Moroccan.df1a57.jpg";